import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

import { A } from '../../common';
import { TYPE, URL } from '../../../constant';
import { useInput, useGbAppLogin, useUserInfo } from '../../../hooks';
import { appKillOnOff, emailRegExp, hideSplash, logoutRemoveStorage, setSubscribe } from '../../../utils/utilityEtc';
import useAmplitude from '../../../hooks/useAmplitude';

function Login() {
  const history = useHistory();
  // const autoLoginEmail = localStorage.getItem('access.email');
  const { t } = useTranslation();
  // const { setInfo } = useUserInfo();
  const { setAmplitudeLog } = useAmplitude();
  const [pwCheck] = useState('');
  const [pwView, setPwView] = useState(false);
  const [emailCheck, setEmailCheck] = useState('');
  
  const [pw, onChangePw, onPwReset] = useInput('');
  // const [email, onChangeEmail, onEmailReset] = useInput(localStorage.getItem('access.email'));
  const [email, onChangeEmail, onEmailReset] = useInput('');
  const { gbAppLogin } = useGbAppLogin();
  const { info } = useUserInfo();

  useEffect(() => {
    hideSplash();
    logoutRemoveStorage();
    appKillOnOff('Y');
    setAmplitudeLog({ eventCategory: 'app_usage', eventName: 'log-in화면 조회'})
    return () => appKillOnOff('N');
  }, []);

  // useEffect(() => {
  //   onChangeEmail(autoLoginEmail ? autoLoginEmail : '');
  // }, [autoLoginEmail]);

  const onBlur = useCallback(() => {
    if (!email) return;
    // 이메일 양식이 맞으면  true 아니면 false;
    const result = emailRegExp(email);
    setEmailCheck(result ? 'success' : 'fail');
  }, [email]);

  const handleChange = (e) => {
    const { name } = e.target;
    if (name === 'email') {
      setEmailCheck('');
      onChangeEmail(e);
    }
  }

  const handleLogin = async () => {
    if (!pw || !email) return;

    try {
      // if(info.isPaymentCountry) await setSubscribe(info?.storeProductID); 
      gbAppLogin(pw, email);
      
    } catch (error) {
      console.log("##### error handleLogin: ", error);
    }
  }

  const handlePwView = useCallback(() => {
    setPwView(!pwView);
  }, [pwView])

  const handlePage = useCallback((path) => {
    if (path === URL.ACCOUNT.JOIN.I) {
      setAmplitudeLog({ eventCategory: 'sign-up', eventName: '회원가입 시작' });
    }
    history.push(path)
  }, [])

  return (
    <div className="layout-def with_bottom_area log_in gm gb">
      <div className="container">
        <div className="inner">
          <div className="btns_wrap cls">
            <div className="app_btn">
              <button 
                className="btn_exit"
                type="button"
                onClick={() => history.goBack()}
              >
                <img src="./static/images/icon/btn_back.svg" alt="뒤로가기" />
              </button>
            </div>
            <div className="tit_gm center_tit24 navy">{t("MY_01_01.msg004")}</div>
          </div>
          <div className="center_wrap">
            <div className="logo_wrap">
              <div className="logo">
                <img src="./static/images/common/img_login_logo.svg" alt="" />
              </div>
            </div>
            <div className="input_wrap">
              <form>
                <article>
                  <div className="input_cont h56">
                    <div className="input_box white_box">
                      <input
                        type="email"
                        value={email ? email : ''}
                        name="email"
                        placeholder={t("MY_00-GM.msg003")}
                        onChange={handleChange}
                        onBlur={onBlur}
                      />
                      <div className="r_area">
                        {(emailCheck === 'success' && email.length > 0) && <img src="./static/images/icon/input_check.svg" alt="" />}
                        {emailCheck === 'fail' && (
                          <button type="button" onClick={onEmailReset}>
                            < img src="./static/images/icon/input_error.svg" alt="" />
                          </button>
                        )}
                      </div>
                    </div>
                    {
                      emailCheck === 'fail' && (
                        <div className="info_txt red">
                          {t("MY_01.msg005")} abc@mathpid.com
                        </div>
                      )
                    }
                  </div>
                </article>
                <article>
                  <div className="input_cont h56">
                    <div className="input_box white_box">
                      <input
                        value={pw}
                        type={pwView ? 'text' : 'password'}
                        placeholder={t("MY_00-GM.msg005")}
                        onChange={onChangePw}
                      />
                      <div className="r_area">
                        <button 
                          type="button"
                          onClick={handlePwView}
                        >
                          {
                            pwView 
                              ? <img src="./static/images/icon/btn_login_eye_on.svg" alt="" />
                              : <img src="./static/images/icon/btn_login_eye_off.svg" alt="" />
                          }
                        </button>
                        {/* <img src="./static/images/icon/input_check.svg" alt="" />
                        <button type="button">
                          <img src="./static/images/icon/input_error.svg" alt="" />
                        </button> */}
                        {(pw.length > 0) && (
                          <button type="button" onClick={onPwReset}>
                            <img src="./static/images/icon/input_delete_40.svg" alt="" />
                          </button>
                        )}
                      </div>
                    </div>
                    {
                      pwCheck === 'fail' && (
                        <div className="info_txt red" dangerouslySetInnerHTML={{ __html: t("MY_00.msg005")}} />
                      )
                    }
                  </div>
                </article>
              </form>
            </div>
            <div className="lower_wrap2">
              <button
                disabled={
                  !emailRegExp(email)
                  || !pw
                }
                className="btn btn-white"
                onClick={handleLogin}
              >{t("MY_00-GM.msg009")}</button>
            </div>
            <div className="lower_wrap3">
              <A onClick={() => handlePage(URL.ACCOUNT.PW_INQUIRY)}>{t("MY_00.msg009")}</A>
            </div>
          </div>
          <div className="btn_wrap">
            <button
              className="btn h56 btn_join"
              onClick={() => handlePage(URL.ACCOUNT.JOIN.I)}
            >
              {t("MY_00.msg008")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;